import { render, staticRenderFns } from "./sdk_partner.vue?vue&type=template&id=54240576&scoped=true"
import script from "./sdk_partner.vue?vue&type=script&lang=js"
export * from "./sdk_partner.vue?vue&type=script&lang=js"
import style0 from "./sdk_partner.vue?vue&type=style&index=0&id=54240576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54240576",
  null
  
)

export default component.exports